import styled from "styled-components";

export const Overlay = styled.div`
  background-color: ${({ theme }) => theme.colors.nrmaBlue};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  z-index: 99;

  p {
    color: ${({ theme }) => theme.colors.white};
    margin-top: 25px;
  }
`;
